<template>
  <ClientOnly>
    <button @click="toggleTheme" class="p-2 rounded hover:bg-gray-200 dark:hover:bg-stone-700 transition">
      <SvgIcon name="light" class="w-5 h-5" v-if="colorMode.value === 'dark'"></SvgIcon>
      <SvgIcon name="dark" class="w-5 h-5" v-else></SvgIcon>
    </button>
  </ClientOnly>
</template>

<script setup lang="ts">
const colorMode = useColorMode();

const toggleTheme = () => {
  colorMode.preference = colorMode.value === 'light' ? 'dark' : 'light';
};
</script>
